import React from 'react';
import rc from '../assets/logos/row crops.svg';
import rch from '../assets/logos/ranches.svg?react';
import pp from '../assets/logos/permanent plantings.svg?react';
import lp from '../assets/logos/leased properties.svg?react';
import rn from '../assets/logos/renewables.svg?react';
import hdq from '../assets/logos/headquarters.svg?react';
import { ThemeIcon, Image } from '@mantine/core';

/**
 * Renders an icon image for a given asset type code (PP, C, LP, RN, RC, HDQ), selecting from SVG assets bundled in the package.
 */
export const AssetTypeIcon = ({
  type,
  style = {}
}: {
  type: 'PP' | 'C' | 'LP' | 'RN' | 'RC' | string;
  style?: object;
}) => {
  let DivIcon = rc;
  if (type == 'RC') DivIcon = rc;
  else if (type == 'PP') DivIcon = pp as any;
  else if (type == 'C') DivIcon = rch as any;
  else if (type == 'LP') DivIcon = lp as any;
  else if (type == 'RN') DivIcon = rn as any;
  else if (type == 'HDQ') DivIcon = hdq as any;
  return (
    <ThemeIcon variant='transparent' style={{ fontSize: 42, color: '#638da5', ...style }}>
      {/*<DivIcon />*/}
      <Image src={DivIcon} />
    </ThemeIcon>
  );
};

export default AssetTypeIcon;
